import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, states } from '@/utils'

import button from '@/components/button'
import preloader from '@/components/preloader'
import ContactListsForm from '@/components/services/contactLists/form'
import ContactsForm from '@/components/services/contacts/form'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: `preloader__holder ${Services.contacts}-dialog__preloader`
    },
    [ h(preloader) ]
  )
}

function renderBody(h) {
  switch (this.type) {
    case `${Services.contacts}.create`: {
      return h(
        ContactsForm,
        {
          class: `${Services.contacts}-form--dialog`,
          props: {
            value: this.restData.contacts.create.data,
            errors: this.restData.contacts.create.errors,
            ListId: this.ListId
          },
          on: {
            input: event => {
              this.restData.contacts.create.data = event
            },
            submit: () => {
              this.create(`${Services.contacts}`)
            },
            validation: event => {
              this.restData.contacts.create.isValid = event
            }
          }
        }
      )
    }
    case `${Services.contacts}.update`: {
      if (this.restData.contacts.get.state === states.ready) {
        return h(
          ContactsForm,
          {
            class: `${Services.contacts}-form--dialog`,
            props: {
              value: this.restData.contacts.get.data,
              errors: this.restData.contacts.update.errors,
              ListId: this.ListId,
              isUpdate: true
            },
            on: {
              input: event => {
                this.restData.contacts.get.data = event
              },
              submit: () => {
                this.update(`${Services.contacts}`)
              },
              validation: event => {
                this.restData.contacts.update.isValid = event
              }
            }
          }
        )
      } else if (this.restData.contacts.get.state === states.loading) {
        return renderPreloader.call(this, h)
      }
      break
    }
    case `${Services.contacts}.remove`: {
      return h(
        'div',
        {
          class: `${Services.contacts}-dialog__content`
        },
        [ this.getTranslate(`${Services.contacts}.contents.confirm.remove`) ]
      )
    }
    case `${Services.contactLists}.create`: {
      return h(
        ContactListsForm,
        {
          class: `${Services.contacts}-form--dialog`,
          props: {
            value: this.restData.contactLists.create.data,
            errors: this.restData.contactLists.create.errors
          },
          on: {
            input: event => {
              this.restData.contactLists.create.data = event
            },
            submit: () => {
              this.create(`${Services.contactLists}`)
            },
            validation: event => {
              this.restData.contactLists.create.isValid = event
            }
          }
        }
      )
    }
    case `${Services.contactLists}.update`: {
      if (this.restData.contactLists.get.state === states.ready) {
        return h(
          ContactListsForm,
          {
            class: `${Services.contacts}-form--dialog`,
            props: {
              value: this.restData.contactLists.get.data,
              errors: this.restData.contactLists.update.errors
            },
            on: {
              input: event => {
                this.restData.contactLists.get.data = event
              },
              submit: () => {
                this.update(`${Services.contactLists}`)
              },
              validation: event => {
                this.restData.contactLists.update.isValid = event
              }
            }
          }
        )
      } else if (this.restData.contactLists.get.state === states.loading) {
        return renderPreloader.call(this, h)
      }
      break
    }
    case `${Services.contactLists}.remove`: {
      return h(
        'div',
        {
          class: `${Services.contacts}-dialog__content`
        },
        [ this.getTranslate(`${Services.contactLists}.contents.confirm.remove`) ]
      )
    }
  }
}
function renderFooter(h) {
  if (this.actionByType) {
    const { service, method } = this.actionByType

    let actionColor = Colors.primary
    if (method === 'remove') {
      actionColor = Colors.error
    }

    return h(
      'div',
      {
        class: `${Services.contacts}-dialog__footer`,
        slot: 'footer'
      },
      [
        h(
          button,
          {
            props: {
              label: this.getTranslate('misc.buttons.cancel'),
              mode: buttonModes.flat,
              disabled: this.restData[service][method].state === states.loading
            },
            on: {
              click: () => {
                this.$emit('show', false)
              }
            }
          }
        ),

        h(
          button,
          {
            props: {
              label: this.getTranslate(`misc.buttons.${method}`),
              loading: this.restData[service][method].state === states.loading,
              disabled: this.actionDisabled,
              color: actionColor
            },
            on: {
              click: () => {
                this[method](service)
              }
            }
          }
        )
      ]
    )
  }
}

export default function(h) {
  if (this.type) {
    const [ service, type ] = this.type.split('.')

    let maxWidth
    if (this.viewport.breakpoint.mdUp) {
      maxWidth = 420
    }

    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate(`${service}.dialogs.titles.${type}`),
          value: this.show,
          maxWidth
        },
        on: {
          input: event => {
            this.$emit('show', event)
          }
        }
      },
      [
        renderBody.call(this, h),
        renderFooter.call(this, h)
      ]
    )
  }
}
